import React, { useEffect, useState } from 'react'
import PageHead from '../components/PageHead'
import { exportButton, orderStatus } from '../utils/config'
import Button from '../ui/comp/Button'
import { CiExport } from 'react-icons/ci'
import Input from '../ui/forms/Input'
import Select from '../ui/comp/Select'
import { useOrders } from '../hooks/useOrders'
import Container from '../ui/comp/Container'
import NoContent from '../components/NoContent'
import Table from '../ui/Table/Table'
import Thead from '../ui/Table/Thead'
import Td from '../ui/Table/Td'
import Tbody from '../ui/Table/Tbody'
import FormatCurrency from '../utils/FormatCurrency'
import Status from '../ui/Table/Status'
import { FiEye, FiPrinter } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Axios } from '../utils/Axios'

function Orders() {

    const [searchText, setSearchText] = useState("");
    const [orders, setOrders] = useState([])
    const queryClient = useQueryClient()

    const { data } = useOrders();

    useEffect(() => {
        setOrders(data || [])
    }, [data])


    // update status

    const { mutate } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post('/order/status', formData)
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['orders'])
        }
    })

    const handleStatus = (order_id, status) => {
        mutate({ order_id, status })
    }

    return (
        <div className='w-full relative'>
            <PageHead title="Orders" />


            {/* Filter palce */}
            <div className="flex items-center justify-between w-full mt-8">
                <div className='max-w-48 w-full'>
                    <Button
                        onClick={() => exportButton("orders")}
                        color={'primary'}
                        icon={<CiExport size={18} />}
                    >
                        Export
                    </Button>
                </div>

                <div className='flex items-center gap-3'>
                    <Input placeholder="Customer name" onChange={(e) => {
                        setSearchText(e.target.value)
                    }} />
                    <Select classic>
                        <option value='all'>Status</option>
                    </Select>
                </div>
            </div>


            {/* orders */}
            <div className="mt-8 w-full relative">
                {orders ? (

                    <Container>
                        <Table>
                            <Thead>
                                <tr>
                                    <Td>Order No.</Td>
                                    <Td>Order Time</Td>
                                    <Td>Customer Name</Td>
                                    <Td>Method</Td>
                                    <Td>Amount</Td>
                                    <Td>Status</Td>
                                    <Td>Actions</Td>
                                    <Td>Invoice</Td>
                                </tr>
                            </Thead>

                            <Tbody>
                                {orders?.filter(order => order?.User?.firstname?.toLowerCase()?.includes(searchText.toLowerCase())
                                    || order?.User?.lastname?.toLowerCase()?.includes(searchText.toLowerCase())
                                    || Number(searchText) === Number(order?.orderNumber)
                                )?.map((order, i) => (
                                    <tr key={i}>
                                        <Td>{order?.orderNumber}</Td>
                                        <Td>
                                            {new Date(order?.iat).toLocaleString('en-US',
                                                {
                                                    month: 'short', day: '2-digit', year: 'numeric',
                                                })}
                                        </Td>
                                        <Td>{order?.User?.firstname}</Td>
                                        <Td>{order?.payment_mode}</Td>
                                        <Td><FormatCurrency amount={order?.total} /></Td>
                                        <Td><Status status={order?.status} /></Td>
                                        <Td>
                                            <Select value={order?.status} onChange={(e) => handleStatus(order?.id, e.target?.value)}>
                                                {orderStatus.map((list, i) => (
                                                    <option key={i} value={`${list}`}>{list}</option>
                                                ))}
                                            </Select>
                                        </Td>
                                        <Td>
                                            <div className="flex items-center gap-3 text-gray-500">
                                                <Link className='text-primary' to={`/orders/${order?.id}`} title='View'><FiEye size={20} /></Link>
                                                <button title='Print'><FiPrinter size={20} /></button>
                                            </div>
                                        </Td>
                                    </tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Container>

                ) : <NoContent />}
            </div>

        </div>
    )
}

export default Orders